import { Component } from '@angular/core';

@Component({
  selector: 'app-file-invoice-icon',
  templateUrl: './file-invoice-icon.component.html',
  styleUrl: './file-invoice-icon.component.scss',
})
export class FileInvoiceIconComponent {}
